export default {
    getStoredUser: (state) => {
        return state.users
    },
    getStoredUserById: (state) => (userId) => {
        return state.users.find(user => user.id === userId)
    }
}
